import http from '@/api/http';
import { serialize } from '@/utils/format';

export async function listSt(token, projectId) {
    try {

        // console.log(query);

        const response = await http.get('api/v1/status?project=' + projectId,
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function updateStatus(token, data) {
    try {
        let dataPram = {
            'title': data.title,
            'description': data.description,
            'color': data.color
        }
        if (data.id > 0) {
            dataPram['id'] = data.id
        } else {
            dataPram['project'] = data.project_id
        }

        // console.log(dataPram);
        const response = await http.post('api/v1/status',
            dataPram,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function delStatus(token, id) {
    try {
        const response = await http.delete('api/v1/status?id=' + id, {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
        })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function updateTask(token, data) {
    try {
        let dataPram = {
            'title': data.title,
            'description': data.description,
            'color': data.color,
            'status': data.status_id,
            'priority': data.priority,
            'completion_percent': data.completion_percent
        }
        if (data.id > 0) {
            dataPram['id'] = data.id
        }

        // console.log(dataPram);
        const response = await http.post('api/v1/task',
            dataPram,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function updateSubTask(token, data) {
    try {
        let dataPram = {
            'title': data.title,
            'description': data.description,
            'color': data.color,
            'parent_id': data.parent_id,
            'task': true,
            'priority': data.priority
        }
        if (data.id > 0) {
            dataPram['id'] = data.id
        }

        // console.log(dataPram);
        const response = await http.post('api/v1/subtask',
            dataPram,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function updateTaskDate(token, data) {
    try {
        let dataPram = {}

        if (data.date_planned_start) {
            dataPram['start'] = data.date_planned_start
        }

        if (data.date_planned_end) {
            dataPram['end'] = data.date_planned_end
        }

        if (data.id > 0) {
            dataPram['id'] = data.id
        }

        // console.log(dataPram);
        const response = await http.get('api/v1/task/planned-date?' + serialize(dataPram), {
            headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data', }
        })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function updateSubTaskDate(token, data) {
    try {
        let dataPram = {}

        if (data.date_planned_start) {
            dataPram['start'] = data.date_planned_start
        }

        if (data.date_planned_end) {
            dataPram['end'] = data.date_planned_end
        }

        if (data.id > 0) {
            dataPram['id'] = data.id
        }

        // console.log(dataPram);
        const response = await http.get('api/v1/subtask/planned-date?' + serialize(dataPram), {
            headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data', }
        })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function clearTaskDate(token, data) {
    try {
        let dataPram = {}

        if (!data.date_planned_start) {
            dataPram['start'] = 1
        }

        if (!data.date_planned_end) {
            dataPram['end'] = 1
        }

        if (data.id > 0) {
            dataPram['id'] = data.id
        }

        // console.log(dataPram);
        const response = await http.delete('api/v1/task/planned-date?' + serialize(dataPram), {
            headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data', }
        })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function clearSubTaskDate(token, data) {
    try {
        let dataPram = {}

        if (!data.date_planned_start) {
            dataPram['start'] = 1
        }

        if (!data.date_planned_end) {
            dataPram['end'] = 1
        }

        if (data.id > 0) {
            dataPram['id'] = data.id
        }

        // console.log(dataPram);
        const response = await http.delete('api/v1/subtask/planned-date?' + serialize(dataPram), {
            headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data', }
        })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function delTask(token, id) {
    try {
        const response = await http.delete('api/v1/task?id=' + id, {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
        })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function delSubTask(token, id) {
    try {
        const response = await http.delete('api/v1/subtask?id=' + id, {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
        })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function archTask(token, id) {
    try {
        const response = await http.delete('api/v1/task?id=' + id, {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
        })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function archTaskList(token, id) {
    try {
        const response = await http.get('api/v2/archive/task?project=' + id, {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
        })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }    
}

export async function listPerformers(token, taskId) {
    try {
        // console.log(query);
        const response = await http.get('api/v1/contractor',
            {
                'id': taskId,
                'subtask': false
            },
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function assignPerformer(token, data) {
    try {
        let dataPram = {
            'id': data.task_id,
            'subtask': data.subtask,
            'user': data.performer_id
        }

        const response = await http.post('api/v1/contractor', 
            dataPram,
            {
                headers: { 
                    'Authorization': 'Bearer ' + token, 
                    'Content-Type': 'multipart/form-data'
                }
            })

        return response.data
    } catch (error) {
        console.log(error.response)
        return null        
    }
}

export async function detachPerformer(token, data) {
    try {
        let dataPram = {
            'id': data.task_id,
            'subtask': data.subtask,
            'user': data.performer_id
        }

        const response = await http.get('api/v1/contractor/delete?' + serialize(dataPram), 
            {
                headers: { 
                    'Authorization': 'Bearer ' + token, 
                    'Content-Type': 'application/json'
                }
            })

        return response.data
    } catch (error) {
        console.log(error.response)
        return null        
    }
}

export async function listControllers(token, taskId) {
    try {
        // console.log(query);
        const response = await http.get('api/v3/control',
            {
                'id': taskId,
                'subtask': false
            },
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function assignController(token, data) {
    try {
        let dataPram = {
            'id': data.task_id,
            'subtask': data.subtask,
            'user': data.controller_id
        }

        const response = await http.post('api/v3/control', 
            dataPram,
            {
                headers: { 
                    'Authorization': 'Bearer ' + token, 
                    'Content-Type': 'multipart/form-data'
                }
            })

        return response.data
    } catch (error) {
        console.log(error.response)
        return null        
    }
}

export async function detachController(token, data) {
    try {
        let dataPram = {
            'id': data.task_id,
            'subtask': data.subtask,
            'user': data.controller_id
        }

        const response = await http.get('api/v3/control/delete?' + serialize(dataPram), 
            {
                headers: { 
                    'Authorization': 'Bearer ' + token, 
                    'Content-Type': 'application/json'
                }
            })

        return response.data
    } catch (error) {
        console.log(error.response)
        return null        
    }
}

export async function uploadFiles(token, data) {
    try {
        for (var pair of data.entries()) {
            console.log(pair[0]+ ', ' + pair[1]); 
        }     
        const response = await http.post('api/v1/task/file', data,
            {
                headers: { 
                    'Authorization': 'Bearer ' + token, 
                    'Content-Type': 'multipart/form-data'
                }
            })

        return response.data
    } catch (error) {
        console.log(error.response)
        return null        
    }
}

export async function uploadSubFiles(token, data) {
    try {
        for (var pair of data.entries()) {
            console.log(pair[0]+ ', ' + pair[1]); 
        }     
        const response = await http.post('api/v1/subtask/file', data,
            {
                headers: { 
                    'Authorization': 'Bearer ' + token, 
                    'Content-Type': 'multipart/form-data'
                }
            })

        return response.data
    } catch (error) {
        console.log(error.response)
        return null        
    }
}

export async function deleteFile(token, id) {
    try {
        const response = await http.delete('api/v1/task/file?id=' + id, {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
        })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function deleteSubFile(token, id) {
    try {
        const response = await http.delete('api/v1/subtask/file?id=' + id, {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
        })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}
export async function addTaskComment(token, data) {
    try {
        let dataPram = {
            'body': data.body,
            'task_id': data.task_id,
            'subtask': data.isSubtask,
            'reply': data.replyTo
        }

        // console.log(dataPram);
        const response = await http.post('api/v2/comment',
            dataPram,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}
export async function deleteTaskComment(token, data) {
    try {
        let dataPram = {
            'id': data.id,
            'subtask': data.isSubtask,
        }

        const response = await http.get('api/v2/comment/delete?' + serialize(dataPram), {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
        })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}
export async function searchTags(token, data) {
    try {
        let dataPram = {
            'name': data.name,
            'project': data.projectId
        }

        const response = await http.get('api/v2/hashtag/search?' + serialize(dataPram), {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
        })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}
export async function addTag(token, data) {
    try {
        let dataPram = {
            'name': data.name,
            'task_id': data.task_id,
            'subtask': data.isSubtask
        }

        // console.log(dataPram);
        const response = await http.post('api/v2/hashtag/',
            dataPram,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}
export async function removeTag(token, data) {
    try {
        let dataPram = {
            'name': data.name,
            'task_id': data.task_id,
            'subtask': data.isSubtask
        }

        // console.log(dataPram);
        const response = await http.post('api/v2/hashtag/remove',
            dataPram,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}
export async function uploadCover(token, data) {
    try {
        const response = await http.post('api/v1/task/image', data,
            {
                headers: { 
                    'Authorization': 'Bearer ' + token, 
                    'Content-Type': 'multipart/form-data'
                }
            })
        return response.data
    } catch (error) {
        console.log(error.response)
        return null        
    }
}
export async function removeCover(token, id) {
    try {
        const response = await http.delete('api/v1/task/image?id=' + id, {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
        })
        return response.data
    } catch (error) {
        console.log(error.response)
        return null
    }
}
export async function completeTask(token, data) {
    try {
        let response,
            url = 'api/v1/task/completed-date?id=' + data.id,
            h = { headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data'} }

        if (data.complete) {
            response = await http.get(url, h)
        } else {
            response = await http.delete(url, h)
        }
        return response.data
    } catch (error) {
        console.log(error.response)
        return null        
    }
}
export async function completeSubTask(token, data) {
    try {
        let response,
            url = 'api/v1/subtask/completed-date?id=' + data.id,
            h = { headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data'} }

        if (data.complete) {
            response = await http.get(url, h)
        } else {
            response = await http.delete(url, h)
        }
        return response.data
    } catch (error) {
        console.log(error.response)
        return null        
    }
}
export async function updateCheck(token, data) {
    try {
        let dataParam = {
            'is_done': data.is_done
        }

        if (data.id) {
            dataParam["id"] = data.id
        }
        if (data.id_task) {
            dataParam["id_task"] = data.id_task
        }        
        if (data.name) {
            dataParam["name"] = data.name
        }        
        
        const response = await http.post('api/v1/task/check',
            dataParam,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}
export async function deleteCheck(token, data) {
    try {
        let dataPram = {
            'id': data.id
        }

        const response = await http.get('api/v1/task/check-del?' + serialize(dataPram), {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
        })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}
export async function sortAll(token, data) {
    try {
        let dataPram = {
            'ids': data
        }

        // console.log(dataPram);
        const response = await http.post('api/v1/status/sort',
            dataPram,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}